import { Button } from "@svea/design-system-components-react";
import { Dialog, P, Stack, Text, useText } from "@sveabank/cc-common";
import { format } from "date-fns";
import Paper from "../../components/paper";
import type { InactiveEngagement } from "../../types/application";
import NoClcCandidateModal from "./no-clc-candidate-modal";

type Props = {
	clcCandidates: InactiveEngagement[];
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
	connectOrgNr: (orgNr: string) => Promise<void>;
};

const ChooseClcCompanyModal = ({ clcCandidates, isOpen, setOpen, connectOrgNr }: Props) => {
	const [t, texts] = useText();

	if (clcCandidates.length === 1) {
		return <NoClcCandidateModal isOpen={isOpen} setOpen={setOpen} />;
	}

	return (
		<Dialog
			isOpen={isOpen}
			size="small"
			center
			heading={t(texts.newCompany.chooseClcCompany.heading)}
			icon="warning"
			isDismissable={false}
		>
			<Dialog.Content>
				<Stack gap={6}>
					<P>{t(texts.newCompany.chooseClcCompany.text)}</P>
					{clcCandidates.map((clcCandidate) => (
						<Paper className="bg-background-tertiary" key={clcCandidate.orgNr}>
							<Stack gap={4}>
								<Stack gap={1}>
									<Stack direction="row" justify="between">
										<Text bold>{t(texts.newCompany.setOrgNumber.companyName)}</Text>
										<Text>{clcCandidate.name}</Text>
									</Stack>
									<Stack direction="row" justify="between">
										<Text bold>{t(texts.newCompany.setOrgNumber.organisationNumber)}</Text>
										<Text>{clcCandidate.orgNrDisplayName}</Text>
									</Stack>
									<Stack direction="row" justify="between">
										<Text bold>{t(texts.newCompany.setOrgNumber.registrationDate)}</Text>
										<Text>{format(clcCandidate.registrationDate, "yyyy-MM-dd")}</Text>
									</Stack>
								</Stack>
								<Button
									data-tracking-action="Verify CLC Organisation Number"
									variant="secondary"
									onPress={async () => {
										await connectOrgNr(clcCandidate.orgNr);
										setOpen(false);
									}}
								>
									{t(texts.newCompany.chooseClcCompany.buttonText)}
								</Button>
							</Stack>
						</Paper>
					))}
				</Stack>
			</Dialog.Content>
		</Dialog>
	);
};

export default ChooseClcCompanyModal;
